module.exports = __webpack_public_path__ + "media/printed-materials/educators-02-marketing-handout-frontback-b3a1a47d.png";